module.exports = __webpack_public_path__ + "static/bottom-07372f0fda82a73f80a5eee7fb19d90c.png";